
import { diff_match_patch, DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL } from 'diff-match-patch';

const dmp = new diff_match_patch();

export function createDiffHtml(text1: string, text2: string): string {
  const diffs = dmp.diff_main(text1, text2);
  dmp.diff_cleanupSemantic(diffs);

  return diffs.map(([op, data]) => {
    const sanitizedData = data.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
    switch (op) {
      case DIFF_INSERT:
        return `<ins style="background-color: #d4edda; text-decoration: none;">${sanitizedData}</ins>`;
      case DIFF_DELETE:
        return `<del style="background-color: #f8d7da; text-decoration: none;">${sanitizedData}</del>`;
      case DIFF_EQUAL:
        return `<span>${sanitizedData}</span>`;
    }
  }).join('');
}
